import React from 'react';
import { AIDesignerExamplePreset } from '../examplePresets';

interface ExampleStripProps {
  presets: AIDesignerExamplePreset[];
  onSelect: (preset: AIDesignerExamplePreset) => void;
  disabled?: boolean;
}

const ExampleStrip: React.FC<ExampleStripProps> = ({ presets, onSelect, disabled = false }) => (
  <div>
    <div className="mb-4 flex items-center gap-2.5">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-100">
        <i className="fas fa-lightbulb text-sm text-secondary-600" />
      </span>
      <div>
        <p className="text-sm font-semibold text-gray-900">Or start from an example</p>
        <p className="text-xs text-gray-500">Load a sample garment and start designing</p>
      </div>
    </div>

    <div className="space-y-3">
      {presets.map((preset) => (
        <button
          key={preset.id}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(preset)}
          className={`group flex w-full items-center gap-4 rounded-2xl border border-gray-200 bg-white p-3 text-left shadow-sm transition-all duration-300 ${
            disabled
              ? 'cursor-not-allowed opacity-50'
              : 'hover:-translate-y-0.5 hover:border-secondary-400 hover:shadow-md'
          }`}
          title={preset.name}
        >
          <div className="h-20 w-24 flex-shrink-0 overflow-hidden rounded-xl bg-gray-100">
            <img
              src={preset.clothPreview}
              alt={preset.name}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-gray-900">{preset.name}</p>
            <p className="mt-0.5 line-clamp-2 text-xs text-gray-500">{preset.prompt}</p>
          </div>
          <i className="fas fa-arrow-right text-xs text-gray-300 transition-colors group-hover:text-secondary-500" />
        </button>
      ))}
    </div>
  </div>
);

export default ExampleStrip;
